import { render, staticRenderFns } from "./main.vue?vue&type=template&id=6d23a122&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d23a122",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d23a122')) {
      api.createRecord('6d23a122', component.options)
    } else {
      api.reload('6d23a122', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=6d23a122&scoped=true", function () {
      api.rerender('6d23a122', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/tableResult/main.vue"
export default component.exports